import { Cookies } from './Cookies';
let instanceCache = null;
/**
 * Return and cache the FWN Cookies instance.
 */
export function instanceGetter() {
    return instanceCache ?? (instanceCache = new Cookies());
}
